import PaymentRequests from './index.vue'
export default PaymentRequests